import DiamondRoundedIcon from '@mui/icons-material/DiamondRounded';
import DirectionsCarRoundedIcon from '@mui/icons-material/DirectionsCarRounded';
import HomeWorkRoundedIcon from '@mui/icons-material/HomeWorkRounded';
import Grid from '@mui/material/Grid';
// import { showRealEstateDialog, showVehicleDialog } from 'components/Dialogs/AssetDialog/actions'; when KBB is ready
import Typography from '@mui/material/Typography';
import { accountsTypes } from 'app-components/flux/accounts';
import { tracker } from 'app-components/utils/core';
import assetsPiChart from 'assets/icons/asset-discovery/assetsPiChart.svg';
import { showRealEstateDialog } from 'components/Dialogs/AssetDialog/actions';
import QPanelButton from 'components/QPanelButton';
import type { DateTime } from 'luxon';
import React, { useMemo } from 'react';
import { useDispatch } from 'react-redux';
import { makeStyles } from 'tss-react/mui';

const useStyles = makeStyles()((theme) => ({
  root: {
    paddingTop: 24,
  },
  headlineRoot: {
    padding: '10px 60px 10px 175px',
  },
  headlineIcon: {
    position: 'absolute',
  },
  typeSelectorRoot: {
    padding: '0 24px',
    justifyContent: 'space-between',
    flexDirection: 'column',
    marginLeft: 145,
    marginRight: 0,
  },
  typeSelectorBtnRoot: {
    background: theme.palette.background.default,
    border: `1px solid ${theme.palette.border.main}`,
    borderRadius: 20,
    width: 525,
    height: 94,
    flexDirection: 'row',
    display: 'flex',
    justifyContent: 'space-between',
    '&:hover': {
      cursor: 'pointer',
      backgroundColor: theme.palette.action.hover,
    },
    '&:focus': {
      cursor: 'pointer',
      backgroundColor: theme.palette.background.paper,
    },
  },
}));

const NonConnectedAsset = (props: {
  onClose: (event: any, reason: string) => void;
  setPage: React.Dispatch<React.SetStateAction<string>>;
  setDefaultVals: React.Dispatch<
    React.SetStateAction<{
      accountName?: string;
      accountType?: accountsTypes.AccountTypeNode;
      statementDate?: DateTime;
      statementBalance?: string;
    }>
  >;
}) => {
  const { onClose, setPage, setDefaultVals } = props;
  const dispatch = useDispatch();
  const { classes } = useStyles();
  const buttonOptions = useMemo(
    () => [
      {
        title: 'Real Estate',
        icon: <HomeWorkRoundedIcon />,
        details: 'Track your real estate investments manually or with Zillow.',
        onClick: () => {
          tracker.track(tracker.events.addAssetsUX_1, { userAction: 'real estate' });
          dispatch(showRealEstateDialog());
          onClose(null, '');
        },
        id: 'realestate',
      },
      {
        title: 'Vehicle',
        icon: <DirectionsCarRoundedIcon />,
        details: 'Track your car.',
        // details: "Add your car, and we'll track its value with Kelley Blue Book.",
        onClick: () => {
          setDefaultVals({
            accountType: accountsTypes.AccountTypeNodesTree.find(({ id }) => id === 'ASSET')?.children?.find?.(
              ({ id }) => id === 'VEHICLE',
            ),
          });
          tracker.track(tracker.events.addAssetsUX_1, { userAction: 'vehicle' });
          setPage('ADD_NON_CONNECTED_ACCOUNT');
          // dispatch(showVehicleDialog); for when KBB is implemented
          // onClose(null, '');
        },
        id: 'vehicle',
      },
      {
        title: 'Other Assets',
        icon: <DiamondRoundedIcon />,
        details: 'Track things like artwork, fine china, collectibles, gold and more!',
        onClick: () => {
          setDefaultVals({
            accountType: accountsTypes.AccountTypeNodesTree.find(({ id }) => id === 'ASSET')?.children?.find?.(
              ({ id }) => id === 'OTHER_ASSET',
            ),
          });
          tracker.track(tracker.events.addAssetsUX_1, { userAction: 'other assets' });
          setPage('ADD_NON_CONNECTED_ACCOUNT');
        },
        id: 'otherassets',
      },
    ],
    [dispatch, onClose, setDefaultVals, setPage],
  );

  return (
    <div className={classes.root}>
      <img className={classes.headlineIcon} src={assetsPiChart} alt='' />
      <Grid item container>
        <Grid className={classes.headlineRoot} item container>
          <Typography variant='headlineMedium'>Select an asset you want to track</Typography>
        </Grid>
        <Grid className={classes.typeSelectorRoot} item container>
          {buttonOptions.map((items) => (
            <QPanelButton
              className={classes.typeSelectorBtnRoot}
              id={items.id}
              key={items.id}
              onClick={items.onClick}
              title={items.title}
              startIcon={items.icon}
              subtitle={items.details}
            />
          ))}
        </Grid>
      </Grid>
    </div>
  );
};

export default NonConnectedAsset;
